export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-jcb.f1cddad5.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};